import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import onClickOutside from 'react-onclickoutside'
import { Img } from 'containers/misc'
import styles from './dropdown.styl'

@onClickOutside
class Dropdown extends Component {
  static propTypes = {
    onItemClick: PropTypes.func,
    onAction: PropTypes.func,
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    photoUrl: PropTypes.string,
    actions: PropTypes.array.isRequired,
    simple: PropTypes.bool
  }

  static defaultProps = {
    simple: false,
    onItemClick: () => {}
  }

  constructor(props) {
    super(props)
    this.state = {
      open: false
    }
  }

  handleToggle = () => this.setState({ open: !this.state.open })

  handleItemClick = (item, e) => {
    this.setState({ open: false })

    if (this.props.onAction && item.type === 'button') {
      this.props.onAction(item.action)
      e.preventDefault()
    }
  }

  handleClickOutside = () => this.setState({ open: false })

  render() {
    const {
      title,
      subtitle,
      photoUrl,
      actions,
      simple,
      onItemClick
    } = this.props
    const { open } = this.state
    const simpleClass = simple ? styles.simple : ''

    return (
      <div className={`${styles.dropdown} ${simpleClass}`}>
        <button
          className={styles.actionMain}
          onClick={this.handleToggle}
        >
          {!simple &&
            <div className={styles.avatar}>
              {photoUrl &&
                <Img
                  src={photoUrl}
                  alt="Profile picture"
                  width={30}
                  height={30}
                />}
              {!photoUrl &&
                <span className={`ico ico--user ${styles.icoCustom} `} />}
            </div>}
          <span className={styles.title}>{title}</span>
          <span className={styles.subtitle}>{subtitle}</span>

          <span className={`ico ico--chevron-down ${styles.icoList}`} />
        </button>
        {open &&
          <ul className={styles.list}>
            {actions.map((item, index) => {
              if (item.hide) {
                return null
              }

              return (
                <li
                  key={index}
                  className={styles.item}
                  onClick={() => onItemClick(item)}
                >
                  <Link
                    to={item.type === 'button' ? '' : item.action}
                    className={styles.link}
                    onClick={(e) => this.handleItemClick(item, e)}
                  >
                    {item.intlKey
                      ? <FormattedMessage
                          id={item.intlKey}
                          defaultMessage={item.label}
                        />
                      : item.label}
                  </Link>
                </li>
              )
            })}
          </ul>}
      </div>
    )
  }
}

export default Dropdown
